module.exports = __webpack_public_path__ + "static/media/comming-soon.8cd5c14f.svg";